// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

console.log("Loading Even Session Report Controller");

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["simulationCount", "skillCount", "fieldCount"];
  static values = {
    id: String,
    event: String,
  };

  connect() {
    // Only load participant data if we have both required values
    if (this.hasIdValue && this.hasEventValue) {
      this.loadParticipantData();
    } else if (
      this.hasSimulationCountTarget ||
      this.hasSkillCountTarget ||
      this.hasFieldCountTarget
    ) {
      // If we have any of the targets but no values, set them to 0
      this.setDefaultState();
    }
  }

  setDefaultState() {
    if (this.hasSimulationCountTarget)
      this.simulationCountTarget.textContent = "0";
    if (this.hasSkillCountTarget) this.skillCountTarget.textContent = "0";
    if (this.hasFieldCountTarget) this.fieldCountTarget.textContent = "0";
  }

  async loadParticipantData() {
    try {
      const response = await fetch(
        `/event_sessions/participant_ratings_data?event_id=${this.eventValue}&participant_id=${this.idValue}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.error) {
        throw new Error(data.error);
      }

      this.simulationCountTarget.textContent = data.simulationCount;
      this.skillCountTarget.textContent = data.skillCount;
      this.fieldCountTarget.textContent = data.fieldCount;
    } catch (error) {
      console.error("Error loading participant data:", error);
      this.setErrorState();
    }
  }

  setErrorState() {
    if (this.hasSimulationCountTarget)
      this.simulationCountTarget.textContent = "Error";
    if (this.hasSkillCountTarget) this.skillCountTarget.textContent = "Error";
    if (this.hasFieldCountTarget) this.fieldCountTarget.textContent = "Error";
  }
}
